
const Skills = ()=>{
    return(
        <section id='skills'className="hid">
        <div className="flex justify-center items-center">
            <h1 className="header">SKILLS</h1>
            <img src="/img/icons/skills.PNG" className="w-16 h-16 md:w-20 md:h-20"alt="" />
        </div>
        <div className="mt-6 md:flex md:justify-evenly md:ml-0 ml-5 grid grid-cols-4 gap-2">
            <div className="inline-block">
                <img src="/img/icons/html.PNG" className="img"alt="" />
                <p className="txt">HTML</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/css.PNG" className="img"alt="" />
                <p className="txt">CSS</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/bootstrap.PNG" className="img"alt="" />
                <p className="txt">BOOTSTRAP</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/sass.PNG" className="img"alt="" />
                <p className="txt">SASS</p>
            </div>
            <div className="inline-block ">
                <img src="/img/icons/javascript.PNG" className="img"alt="" />
                <p className="txt">JAVASCRIPT</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/php.PNG" className="img"alt="" />
                <p className="txt">PHP</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/sql.PNG" className="img"alt="" />
                <p className="txt">SQL</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/tailwind.JPG" className="object-contain img"alt="" />
                <p className="txt">TAILWIND CSS</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/react.PNG" className="img"alt="" />
                <p className="txt">REACT.JS</p>
            </div>

            <div className="inline-block">
                <img src="/img/icons/flutter.PNG" className="img"alt="" />
                <p className="txt">FLUTTER</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/python.PNG" className="img"alt="" />
                <p className="txt">PYTHON</p>
            </div>
            <div className="inline-block">
                <img src="/img/icons/next.PNG" className="img"alt="" />
                <p className="txt">LEARNABLE</p>
            </div>

        </div>
        <div className="mt-5">
            <h3 className="text-center text-md">SOFT SKILLS</h3>
            <div className="md:flex md:justify-evenly grid grid-cols-2 gap-1 mt-2 p-2">
                <p className="ss">Problem Solving</p>
                <p className="ss">Critical Thinking</p>
                <p className="ss">Team Work</p>
                <p className="ss">Adaptability</p>
                <p className="ss">Integrity</p>
                <p className="ss">Empathy</p>
                <p className="ss">efficient interaction</p>
                <p className="ss">Learnability</p>
                <p className="ss">Jovial Sense of Humor</p> 
                <p className="ss">Time management</p>  
                
                


            </div>
        </div>
        </section>
   
    )

}
export default Skills;